export default __webpack_public_path__ + "static/media/progress.a45548b0.svg";